/* eslint-disable no-console */

export default function exposeDevTools(store) {
  if (typeof window !== "undefined") {
    window.setcountry = function(countryCode) {
      if (typeof countryCode !== "string" || countryCode.length !== 2) {
        console.error('Niepoprawny kod kraju. Użyj np. "PL", "DE".');
        return;
      }
      store.commit("setUserCountry", countryCode.toUpperCase());
      console.log(`Kraj ustawiony na: ${countryCode.toUpperCase()}`);
    };

    window.checkcountry = function() {
      console.log("Aktualny stan:", store.state.userCountry);
    };
  }
}
